import { Box, Card, CardActionArea, CardContent, Divider, Typography } from '@mui/material'
import { getLocaleFromFullDate } from 'common/libs/fechas'
import { getChipSolicitud } from '../libs/SolicitudesHelpers'

const SolicitudCard = ({ data, onClick = () => {}, structure = {} }) => {
  const handleClick = (e) => {
    onClick(e)
  }
  return (
    <Card>
      <CardActionArea data-solicitud={data.id} onClick={handleClick}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            {getChipSolicitud(data.status, data.d_status)}
          </Box>
          <Box>
            <Typography variant="h6" sx={{ lineHeight: '1.25rem', mb: 1 }}>
              {data.d_tipo}
            </Typography>
            <Typography variant="subtitle">
              {data.status_fecha ? getLocaleFromFullDate(data?.status_fecha) : ''}
            </Typography>
            <Divider textAlign="left" sx={{ mt: 2 }}>
              Solicitante
            </Divider>
            <Typography variant="body2">{data.d_dni}</Typography>
            {data.campos_listado?.length > 0 && (
              <>
                <Divider sx={{ mt: 2 }} />
                {data.campos_listado.map((c) => (
                  <Box key={c.codigo_campo} sx={{ mt: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      {c.etiqueta}
                    </Typography>
                    <Typography variant="body2">{c.valor}</Typography>
                  </Box>
                ))}
              </>
            )}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default SolicitudCard
